// Tech-web pages that must always be reachable from the sidebar after a manual
// login. The side menu itself comes from `/side-menu/web`; these entries are
// only added when that response doesn't already route to them.
export const TECH_HOME_ROUTE = '/dashboard';

const TECH_MENU = [
    {
        name: 'Dashboard',
        icon: 'dashboard-calendar-icon.png',
        route: TECH_HOME_ROUTE,
        noBadge: true,
    },
    {
        name: 'Work Orders',
        icon: 'work-order-icon.png',
        // Active/hover submenu colour from Figma (Rectangle 308)
        menuHoverColor: '#7695FF',
        submenu: [
            // Names and order as in Figma "Work Orders - Appointments - Active"
            { name: 'Appointments', route: '/work-order/appointment' },
            { name: 'Service & Repair History', route: '/work-order/service-and-repair' },
            { name: 'Replacement Quote History', route: '/work-order/replacement-quote' },
            { name: 'Universal Quotes', route: '/work-order/universal-quotes' },
        ],
    },
];

// Detail pages highlight the listing they belong to in the sidebar (Figma: "Appointments" stays active on an appointment)
const DETAIL_MENU_ROUTE = {
    AppointmentDetail: '/work-order/appointment',
    'appointment-members': '/work-order/appointment',
    'job-detail': '/work-order/service-and-repair',
    'select-unit': '/work-order/service-and-repair',
    'job-members': '/work-order/service-and-repair',
    'last-evaluation': '/work-order/service-and-repair',
    'view-evaluation': '/work-order/service-and-repair',
    'equipment': '/work-order/service-and-repair',
    'initial-check': '/work-order/service-and-repair',
    'summary': '/work-order/service-and-repair',
    'edit-summary': '/work-order/service-and-repair',
    'final-evaluation': '/work-order/service-and-repair',
    'summary-detail': '/work-order/service-and-repair',
    'job-invoice': '/work-order/service-and-repair',
    QuoteDetail: '/work-order/universal-quotes',
    QuoteEdit: '/work-order/universal-quotes',
    'quote-members': '/work-order/universal-quotes',
    'rq-detail': '/work-order/replacement-quote',
    'rq-data-sheet': '/work-order/replacement-quote',
    'rq-summary': '/work-order/replacement-quote',
    'rq-summary-edit': '/work-order/replacement-quote',
};

export function menuRouteFor(route) {
    return DETAIL_MENU_ROUTE[route.name] || route.path;
}

const collectRoutes = (items, routes = new Set()) => {
    (items || []).forEach(item => {
        if (item.route) routes.add(item.route);
        if (item.submenu) collectRoutes(item.submenu, routes);
    });
    return routes;
};

// true when the (role-filtered) API side menu links to `route` — pages that are menu-only (System Designer,
// Admin Utilities) use it so a direct URL follows the same rules as the sidebar
export function menuHasRoute(apiMenu, route) {
    return collectRoutes(Array.isArray(apiMenu) ? apiMenu : []).has(route);
}

// true when the side menu has a protection plan page (its cart badge needs plans/cart/detail); no plans → no cart call
export function menuHasPlans(apiMenu) {
    return [...collectRoutes(Array.isArray(apiMenu) ? apiMenu : [])].some(r => /protection-plan|^\/plans\//.test(String(r)));
}

export function withTechMenu(apiMenu) {
    const menu = Array.isArray(apiMenu) ? apiMenu : [];
    const existing = collectRoutes(menu);
    const missing = TECH_MENU
        .map(item => {
            if (!item.submenu) return existing.has(item.route) ? null : { ...item };
            const submenu = item.submenu.filter(sub => !existing.has(sub.route)).map(sub => ({ ...sub }));
            return submenu.length ? { ...item, submenu } : null;
        })
        .filter(Boolean);
    return [...missing, ...menu];
}
